const PORTAL_DEFINITIONS = [
  {
    id: 'staff',
    label: 'Staff Portal',
    localPort: 8081,
    developmentSubdomain: 'staff',
    productionSubdomain: 'staff',
  },
  {
    id: 'ha',
    label: 'Home Health Agency Portal',
    localPort: 8080,
    developmentSubdomain: 'ha',
    productionSubdomain: 'ha',
  },
  {
    id: 'sa',
    label: 'Staffing Agency Portal',
    localPort: 8082,
    developmentSubdomain: 'sa',
    productionSubdomain: 'sa',
  },
  {
    id: 'clinician',
    label: 'Clinician Portal',
    localPort: 8083,
    developmentSubdomain: 'clinician',
    productionSubdomain: 'clinician',
  },
]

const normalizedHostname = (hostname = '') => hostname.trim().toLowerCase()

export const publicPortalEnvironment = (hostname) => {
  const normalized = normalizedHostname(hostname)
  if (normalized === 'localhost' || normalized === '127.0.0.1') {
    return 'local'
  }
  if (
    normalized === 'dev.checkmarq.com' ||
    normalized.endsWith('.dev.checkmarq.com')
  ) {
    return 'development'
  }
  return 'production'
}

export const resolvePublicPortalLinks = ({
  hostname = window.location.hostname,
  protocol = window.location.protocol,
} = {}) => {
  const environment = publicPortalEnvironment(hostname)
  const normalized = normalizedHostname(hostname)

  return PORTAL_DEFINITIONS.reduce((links, portal) => {
    let href
    if (environment === 'local') {
      href = `${protocol}//${normalized}:${portal.localPort}/login`
    } else if (environment === 'development') {
      href = `https://${portal.developmentSubdomain}.dev.checkmarq.com/login`
    } else {
      href = `https://${portal.productionSubdomain}.checkmarq.com/login`
    }

    links[portal.id] = {
      id: portal.id,
      label: portal.label,
      href,
    }
    return links
  }, {})
}
